import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function WelcomeToAlignPhysiotherapy() {
  return <section className="relative bg-background py-16 md:py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center animate-fade-in-up">
          <h1 className="font-display text-4xl md:text-5xl leading-[1.2] tracking-wide font-bold text-foreground mb-6">
            Welcome to Align Physiotherapy
          </h1>
          <p className="text-base leading-[1.6] text-muted-foreground mb-8 max-w-2xl mx-auto">
            At Align Physiotherapy, we provide expert, personalised care tailored to your individual needs. Our modern, evidence-based approach ensures you receive the highest quality treatment in a calm, clinical environment. Whether you're recovering from injury, managing chronic pain, or looking to optimise your movement, our experienced team is here to help you move better, feel better, and get back to doing what you love.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center animate-fade-in-up-delay-100">
            <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary-hover shadow-soft transition-all duration-[150ms] ease-[cubic-bezier(0.34,1.56,0.64,1)] hover:-translate-y-0.5 hover:shadow-medium focus-ring">
              <Link to="/ServicesPage">View Our Services</Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="border border-border hover:bg-accent/10 transition-all duration-[150ms] focus-ring">
              <Link to="/ContactPage">Get In Touch</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}